module.exports = __webpack_public_path__ + "static/media/work1-cover.d1f03c88.jpg";